// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"4dc6ca85","456":"84d6588e","656":"26369c71","756":"4c9af15c","968":"e5d81b12"}[chunkId] + ".chunk.js";
};